<mat-form-field class="w-100">
  <mat-label [innerHTML]="label" class="condensed-label-view"></mat-label>
  <input 
    type="text"
    [disabled]="isDisabled"
    [readonly]="isDisabled"
    matInput
    [formControl]="inputControl"
    [matAutocomplete]="auto"
    [matAutocompleteDisabled]="isDisabled"
    [placeholder]="placeholder">
  <mat-icon matSuffix style="cursor: pointer;" svgIcon="menu-down"></mat-icon>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
    @for (option of filteredOptions(); track option) {
      <mat-option [value]="option">{{option.displayName}}</mat-option>
    }
  </mat-autocomplete>
  <mat-hint class="condensed-help-text" [innerHTML]="helpText" *ngIf="helpText"></mat-hint>
  <mat-error *ngIf="showError">required</mat-error>
</mat-form-field>